import * as Yup from 'yup';

export default Yup.object({
  userName: Yup.string()
    .required('Please enter a username'),
  password: Yup.string()
    .required('Please enter a password'),
});
